
import { eoRendererMixin, metaDataMixin } from '~/mixins'

export default {
  mixins: [
    eoRendererMixin,
    metaDataMixin,
  ],
  layout: 'program',
  scrollToTop: false,
  async asyncData ({ $api, $config, error,  params: { program: slug } }) {
    if (slug) {
      const [
        { data: { items: programs = [] } = {} },
      ] = await Promise.all([
        // Get program for this slug
        $api.programs.getOneBySlug(slug, {
          domain: $config.preprEnvironmentDomainGeneriek,
        }),
      ])

      const program = programs[0]
      if (program.id) {
        return {
          ...program,
          seo: {
            ...program.seo,
            title: `Over: ${program.seo.title}'`,
          },
          social: {
            ...program.social,
            title: `Over: ${program.social.title}'`,
          },
        }
      } else {
        error({
          context: `Couldn't find program: ${slug}.`,
          message: '(404) Programma niet gevonden',
          severity: 'info',
          statusCode: 404,
        })

        return false
      }
    }
  },
  data() {
    return {
      callToActions: [],
      content: [],
      presenters: [],
    }
  },
}
